<p>quickinfo-footer works!</p>
